module.exports = __webpack_public_path__ + "static/media/015.44d28a85.jpg";